module.exports = __webpack_public_path__ + "static/media/ilk.feb3634d.svg";